// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__w1Eki","search":"Settings_search__TOyVn","filter":"Settings_filter__3JN8K"};